module.exports = __webpack_public_path__ + "media/icons/visa-0f5ff989.svg";